// src/services/adminService.js
import axios from '../utils/axios';

// Admin istatistiklerini getir
export const getAdminStats = async () => {
  try {
    const response = await axios.get('/admin/stats');
    return response.data;
  } catch (error) {
    console.error('Admin istatistikleri yüklenirken hata:', error);
    throw error;
  }
};

// Son aktiviteleri getir
export const getRecentActivity = async () => {
  try {
    const response = await axios.get('/admin/activities');
    return response.data;
  } catch (error) {
    console.error('Aktiviteler yüklenirken hata:', error);
    // Fallback: Boş array döndür
    return [];
  }
};

// Öğrenci taleplerini getir
export const fetchStudentRequests = async () => {
  try {
    const response = await axios.get('/student-requests');
    return response.data;
  } catch (error) {
    console.error('Öğrenci talepleri yüklenirken hata:', error);
    throw error;
  }
};

// Talep durumunu güncelle
export const updateRequestStatus = async (id, status) => {
  try {
    const response = await axios.put(`/student-requests/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Talep durumu güncellenirken hata:', error);
    throw error;
  }
};

// Tüm kursları getir (admin için)
export const getAllCourses = async () => {
  try {
    const response = await axios.get('/admin/courses');
    return response.data;
  } catch (error) {
    console.error('Kurslar yüklenirken hata:', error);
    throw error;
  }
};

// Kurs durumunu güncelle
export const updateCourseStatus = async (courseId, status) => {
  try {
    const response = await axios.put(`/admin/courses/${courseId}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Kurs durumu güncellenirken hata:', error);
    throw error;
  }
};

// Kurs sil
export const deleteCourse = async (courseId) => {
  try {
    const response = await axios.delete(`/admin/courses/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Kurs silinirken hata:', error);
    throw error;
  }
};

// Tüm öğrencileri getir
export const getAllStudents = async () => {
  try {
    const response = await axios.get('/admin/students');
    return response.data;
  } catch (error) {
    console.error('Öğrenciler yüklenirken hata:', error);
    throw error;
  }
};

// Öğrenci güncelle
export const updateStudent = async (studentId, data) => {
  try {
    const response = await axios.put(`/admin/students/${studentId}`, data);
    return response.data;
  } catch (error) {
    console.error('Öğrenci güncellenirken hata:', error);
    throw error;
  }
};

// Öğrenci sil
export const deleteStudent = async (studentId) => {
  try {
    const response = await axios.delete(`/admin/students/${studentId}`);
    return response.data;
  } catch (error) {
    console.error('Öğrenci silinirken hata:', error);
    throw error;
  }
};

// Tüm öğretmenleri getir
export const getAllTeachers = async () => {
  try {
    const response = await axios.get('/admin/teachers');
    return response.data;
  } catch (error) {
    console.error('Öğretmenler yüklenirken hata:', error);
    throw error;
  }
};